import LPModal from './LPModal';
import { useSelector } from 'react-redux';
// import { LPElement } from '../../types/LPElement';

interface LPProps {
    bookUri: string;
    bookId: any;
    offset: number;
    lp: any;
}
const LP: React.FC<LPProps> = ({ bookUri, bookId, offset, lp }) => {
    const isopenLP = useSelector(
        (state: { LPOpen: { isOpen: boolean } }) => state.LPOpen.isOpen
    );
    return (
        <>
            {isopenLP && (
                <LPModal chapters={lp?.data?.chapters} offset={offset} />
            )}
        </>
    );
};

export default LP;
